// tslint:disable:max-line-length
import * as React from 'react';

import {Typography, TextField, Dialog, DialogContent, DialogTitle} from '@material-ui/core';
import { connect } from 'react-redux';
import Button from "@components/common/button/Button";
import PhoneAndroidIcon from '@material-ui/icons/PhoneAndroid';
import TranslateNew from "@translate/TranslateNew";
import CordovaContext from 'src/cordovaContext';
import { buttonContainedLarge } from 'src/main.style';
import { getSelectedFamilyResource } from '@services/user/user.utils';

const tn:TranslateNew = TranslateNew.getInstance();

interface IProps {
    user: any;
    icalToken?: string;
    embedded?: boolean;
}


interface IState {
    modalOpen: boolean,
    calendarLink: string
}
  
class ExportEvents extends React.Component<IProps,IState> {
    constructor(props: IProps){
        super(props)
        this.state = {
            modalOpen: false,
            calendarLink: ""
        }
    }



    public handleOpenModal = (link: string) => {
        this.setState({ modalOpen: true, calendarLink: link });
    };

    public handleCloseModal = () => {
        this.setState({ modalOpen: false, calendarLink: '' });
    };


    public handleConfirmModal = () => {
        window.open(this.state.calendarLink, '_blank'); 
        this.handleCloseModal();
    };


  public render() {

    if (!this.props.user.resources || this.props.user.resources.length === 0){
        return (<div>Not logged in</div>);
    }

    return (
        <div>
            <span style={{fontSize:'24px'}}>
              {tn.lang.synchCal}
            </span>
            <div style={{display: 'grid', gridGap: '10px', padding:'12px'}}>
                <CordovaContext.Consumer>
                    {(cordovaApp) => {
                        if (cordovaApp) {
                            return (
                                <div
                                    onClick={(e: any) => { 
                                        this.handleOpenModal("webcal://calendar.varannanvecka.app/ical/" + 
                                        this.props.icalToken + ".ics"); }}
                                >
                                    <Button variant="outlined" fullWidth={true} startIcon={<PhoneAndroidIcon style={{fill:"#9B9595", width:"24px"}}/>}> 
                                        {tn.lang.settingsExportAppleDevice}
                                    </Button>
                                </div>);
                        } else {
                            return (
                                <div
                                    onClick={(e: any) => { 
                                        this.handleOpenModal("webcal://calendar.varannanvecka.app/ical/" + 
                                        this.props.icalToken + ".ics"); }}
                                >
                                    <Button variant="outlined" fullWidth={true} startIcon={<img src={"live.ico"} alt="Logo"  width="24px" style={{paddingRight: '8px'}}/>}> 
                                        {tn.lang.settingsExportOutlook}
                                    </Button>
                                </div>);
                        }
                    }}
                </CordovaContext.Consumer>
                <div
                    onClick={(e: any) => { 
                        this.handleOpenModal("https://calendar.google.com/calendar/r?cid=http://calendar.varannanvecka.app/ical/" + 
                        this.props.icalToken + ".ics");}}
                >
                    <Button variant="outlined" fullWidth={true} startIcon={<img src={"gmail.ico"} alt="Logo" width="24px" style={{paddingRight: '8px'}}/>}> 
                        {tn.lang.settingsExportAppleGmail}
                    </Button>
                </div>
                        
                <div

                    onClick={(e: any) => { 
                        this.handleOpenModal("https://outlook.live.com/owa/?path=/calendar/action/compose&rru=addsubscription&url=" +
                        "https://calendar.varannanvecka.app/ical/" +
                        this.props.icalToken +
                        ".ics" +
                        "&name=Children&mkt=en-001"); }}
                >
                    <Button variant="outlined" fullWidth={true} startIcon={<img src={"live.ico"} alt="Logo"  width="24px" style={{paddingRight: '8px'}}/>}> 
                        {tn.lang.settingsExportOutlookOnline}
                    </Button>
                </div>


                <Typography color="textSecondary" gutterBottom={true}>
                    {tn.lang.settingsExportInfoLinkManuel}
                </Typography>
                <TextField
                  variant='outlined'
                  name="calendar-url"
                  style={{userSelect: "all"}}
                  value={"https://calendar.varannanvecka.app/ical/"+this.props.icalToken+".ics"}
                  placeholder={tn.lang.title}
                  InputLabelProps={{ shrink: false }}
                  onFocus={event => {
                    event.target.select();
                  }}
                />
            </div>
            <Dialog
                open={this.state.modalOpen}
                onClose={this.handleCloseModal}
            >
                <DialogTitle>{tn.lang.synchCal}</DialogTitle>
                <DialogContent>
                    <Typography>
                        {tn.lang.settingsExportDelayInfo} 
                    </Typography>
                </DialogContent>
                <div style={{display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: "10px", margin: "10px"}}> 
                    <Button variant='contained' style={buttonContainedLarge} onClick={this.handleConfirmModal} color="primary">
                    {tn.lang.OK}
                    </Button>
                    <Button onClick={this.handleCloseModal} color="default">
                        {tn.lang.cancel}
                    </Button>
                </div>

            </Dialog>
            
        </div>
        
    );
  }
}

const mapStateToProps = (state: any) => ({
    user: state.user.session.data,
    icalToken: getSelectedFamilyResource(state.user.session)?.icalToken,
    language: state.user.language,
});



export default connect(mapStateToProps)(ExportEvents);


// WEBPACK FOOTER //
// ./src/components/calendar-export/export.calendar.tsx